const marked = require('marked')
import DOMPurify from "dompurify";

export default {
  methods: {
    $renderMarkdown(md) {
      if (!md) return "";
      const html = marked(md, {
        breaks: true,
        gfm: true
      });

      return DOMPurify.sanitize(html);
    }
  }
};

